import { NodeView } from '@tiptap/core';
import { NodeSelection } from 'prosemirror-state';
/**
 * Adding an option to set custom dragImage preview.
 * Simply attach data-drag-preview attribute to the drag handle element that specifies
 * the id of the preview element which will be used as a drag image instead of the node itself.
 * Reason: Node view can contain complex content that we don't want to show as a drag image.
 * Original source code:
 * https://github.com/ueberdosis/tiptap/blob/0c2b2d100d7ca5c483268076edcb90ec931f411d/packages/core/src/NodeView.ts#L71
 * @example
 * <img data-drag-handle data-drag-preview="preview-image" />
 */
NodeView.prototype.onDragStart = function (event: DragEvent) {
  const { view } = this.editor;
  const target = event.target as HTMLElement;

  // get the drag handle element
  // `closest` is not available for text nodes so we may have to use its parent
  const dragHandle =
    target.nodeType === 3
      ? target.parentElement?.closest('[data-drag-handle]')
      : target.closest('[data-drag-handle]');

  if (!this.dom || this.contentDOM?.contains(target) || !dragHandle) {
    return;
  }

  let x = 0;
  let y = 0;

  // calculate offset for drag element if we use a different drag handle element
  if (this.dom !== dragHandle) {
    const domBox = this.dom.getBoundingClientRect();
    const handleBox = dragHandle.getBoundingClientRect();

    // In React, we have to go through nativeEvent to reach offsetX/offsetY.
    const offsetX = event.offsetX ?? (event as any).nativeEvent?.offsetX;
    const offsetY = event.offsetY ?? (event as any).nativeEvent?.offsetY;

    x = handleBox.x - domBox.x + offsetX;
    y = handleBox.y - domBox.y + offsetY;
  }

  // START OF THE PATCH
  const dragPreviewId = target.getAttribute('data-drag-preview');
  const dragPreviewEl = dragPreviewId && document.getElementById(dragPreviewId);
  event.dataTransfer?.setDragImage(dragPreviewEl || this.dom, x, y);
  // END OF THE PATCH
  // Original source code:
  // event.dataTransfer?.setDragImage(this.dom, x, y);

  const pos = this.getPos();

  if (typeof pos !== 'number') {
    return;
  }
  // we need to tell ProseMirror that we want to move the whole node
  // so we create a NodeSelection
  const selection = NodeSelection.create(view.state.doc, pos);
  const transaction = view.state.tr.setSelection(selection);

  view.dispatch(transaction);
};
